const freeBoards = {
    'review': 1002,
    'qna': 4
}

const categories = {
    'cover': 50,
    'about': 49,
    'home': 44,
    'portfolio': {
        '전체': 24,
        '20평대': 45,
        '30평대': 46,
        '40평대': 47,
        '50평이상': 48
    }
}

export {freeBoards, categories}
